import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { IonicModule } from "@ionic/angular";
import { IonicHoverTooltipDirective } from "./ionic-hover-tooltip.directive";
import { TooltipContentComponent } from "./tooltip-content.component";

@NgModule({
  declarations: [IonicHoverTooltipDirective, TooltipContentComponent],
  imports: [CommonModule, IonicModule],
  exports: [IonicHoverTooltipDirective],
})
export class TooltipModule {}
